module.exports = __webpack_public_path__ + "static/media/slide11.287ea860.jpg";